/**
 * Platform/App Configuration
 * These are static values for the platform, not tenant-specific
 */

export const APP_CONFIG = {
  /** Platform name displayed in browser tab and sidebar */
  name: 'ClirxOS',
  
  /** Platform tagline/slogan */
  tagline: 'Smart Clinic & Pharmacy Platform',

  /** Platform description for SEO */
  description: 'Pharmacy & Clinic Management System',
  
  /** Platform favicon path */
  favicon: '/favicon.ico',
  
  /** Default theme color */
  themeColor: '#4f46e5',
} as const;

export type AppConfig = typeof APP_CONFIG;
